document.addEventListener('DOMContentLoaded', () => {
    console.log("🚀 Variant Manager Initialized");

    const CHECK_DELAY_MS = 260;

    // --- Synchronizacja atrybutów 'disabled' ---
    const syncDisabledAttributes = () => {
        const allVariantInputs = document.querySelectorAll('variant-selects input[type="radio"]');
        allVariantInputs.forEach(input => {
            if (input.classList.contains('disabled')) {
                input.setAttribute('disabled', 'disabled');
            } else {
                input.removeAttribute('disabled');
            }
        });
        console.log('🔄 Synchronized disabled attributes with .disabled classes.');
    };

    // --- Główna funkcja sprawdzająca i auto-przełączająca ---
    const checkVariantStates = () => {
        const timestamp = new Date().toLocaleTimeString([], { hour12: false, second: '2-digit', fractionalSecondDigits: 3 });
        console.log(`[${timestamp}] Running checkVariantStates...`);

        document.querySelectorAll('variant-selects').forEach(variantContainer => {
            const radioInputs = variantContainer.querySelectorAll('input[type="radio"]');
            const processedFieldsets = new Set();

            radioInputs.forEach(input => {
                const isChecked = input.checked;
                const isDisabled = input.classList.contains('disabled') || input.hasAttribute('disabled');

                if (isChecked && isDisabled) {
                    const fieldset = input.closest('fieldset');
                    if (!fieldset || processedFieldsets.has(fieldset)) return;
                    processedFieldsets.add(fieldset);

                    const legend = fieldset.querySelector('legend');
                    const optionName = legend ? legend.textContent.trim() : (input.name || 'Option');

                    const firstAvailable = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
                        .find(i => !i.classList.contains('disabled') && !i.hasAttribute('disabled'));

                    if (firstAvailable) {
                        console.log(`⚡ Auto-switching ${optionName} to ${firstAvailable.value}`);
                        firstAvailable.checked = true;
                        firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
                        console.warn(`🚨 ${optionName}: ${input.value} niedostępny! Przełączono na ${firstAvailable.value}`);
                    } else {
                        console.warn(`❌ No available options for ${optionName}`);
                        console.warn(`🚨 Brak dostępnych opcji dla ${optionName}`);
                    }
                }
            });
        });

        syncDisabledAttributes();
    };

    // --- Nasłuchiwanie zmian (delegacja) ---
    document.body.addEventListener('change', (event) => {
        const target = event.target;
        if (target.tagName === 'INPUT' && target.type === 'radio' && target.closest('variant-selects')) {
            const timestamp = new Date().toLocaleTimeString([], { hour12: false, second: '2-digit', fractionalSecondDigits: 3 });
            console.log(`🔄 Change detected: ${target.name} / ${target.value} [${timestamp}]`);
            setTimeout(checkVariantStates, CHECK_DELAY_MS);
        }
    });

    // --- Blokowanie kliknięć w niedostępne opcje ---
    document.body.addEventListener('click', (event) => {
        const target = event.target;
        if (target.tagName === 'INPUT' && target.type === 'radio' && target.classList.contains('disabled')) {
            event.preventDefault();
            console.log(`🚫 Blocked click on disabled: ${target.name} / ${target.value}`);
            alert(`Opcja ${target.value} jest niedostępna!`);
        }
    });

    console.log(`👂 Listeners attached. Delay: ${CHECK_DELAY_MS}ms`);

    // --- Inicjalizacja ---
    setTimeout(() => {
        syncDisabledAttributes();
        checkVariantStates();
    }, Math.max(CHECK_DELAY_MS, 200));
});
